module.exports = __webpack_public_path__ + "static/media/halloween.4c8767fd.jpg";